/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {SegmentListPageComponent} from './segment-list-page.component';

@Component({
  standalone: true,
  imports: [SegmentListPageComponent],
  selector: 'adn-segment-route-page',
  template: `
    <adn-segment-list-page [readOnly]="readOnly"></adn-segment-list-page>
  `
})
export class SegmentRoutePageComponent {
  @Input() readOnly = false;
}
